import { render, staticRenderFns } from "./TopNavSave.vue?vue&type=template&id=523829b6&"
import script from "./TopNavSave.vue?vue&type=script&lang=ts&"
export * from "./TopNavSave.vue?vue&type=script&lang=ts&"
import style0 from "./TopNavSave.vue?vue&type=style&index=0&id=523829b6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports